// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGScreenCapture = props => /*#__PURE__*/_jsx("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M10.316 14v-2.21h-2.21v-1.474h2.21v-2.21h1.473v2.21H14v1.473h-2.21V14h-1.474zM0 11.79V7.86h1.474v2.456H3.93v1.473H0zm0-7.86V0h3.93v1.474H1.474V3.93H0zm10.316 0V1.474H7.86V0h3.93v3.93h-1.474z"
  })
}));
SVGScreenCapture.displayName = 'SVGScreenCapture';
export default SVGScreenCapture;